import PropTypes from "prop-types";
import dayjs from "@shared/dayjs";
import { ClockFiveRegularV6 } from "@shared/v2/Icomoon";

const AppointmentDueness = {
  overdue: "tw-text-brivity-coral-110 tw-bg-brivity-coral-10",
  due_today: "tw-bg-[#FAF1E6] tw-text-[#E5941B]",
  upcoming: "tw-text-brivity-blue-110 tw-bg-blue-10",
  completed: "tw-text-brand-success tw-bg-blue-10",
};
const formatDate = (date) => date.format("MM/DD/YY [@] hh:mm A");

const getFormattedDate = ({ preferScheduledTime, scheduledTime, dueDate }) => {
  const scheduledDate = scheduledTime ? dayjs.unix(scheduledTime) : null;
  const parsedDueDate = dueDate ? dayjs(dueDate) : null;
  const primaryDate = preferScheduledTime ? scheduledDate || parsedDueDate : parsedDueDate || scheduledDate;

  return primaryDate ? formatDate(primaryDate) : "N/A";
};

const AppointmentDueDate = ({ preferScheduledTime, dueness, dueDate, scheduledTime, customClassName }) => (
  <div className={`tw-mt-[4px]  tw-flex tw-items-center ${customClassName} `}>
    <div
      className={`tw-flex tw-items-center tw-px-[8px] tw-h-[24px] tw-rounded-[6px] tw-font-semibold tw-text-12 ${AppointmentDueness[dueness]}`}
    >
      {getFormattedDate({ preferScheduledTime, scheduledTime, dueDate })}
      <span className="tw-pl-[6px] tw-pt-[3px]">
        <ClockFiveRegularV6 />
      </span>
    </div>
  </div>
);

AppointmentDueDate.propTypes = {
  preferScheduledTime: PropTypes.bool,
  dueness: PropTypes.string,
  dueDate: PropTypes.string,
  scheduledTime: PropTypes.number,
  customClassName: PropTypes.string,
};

AppointmentDueDate.defaultProps = {
  preferScheduledTime: false,
  dueness: null,
  dueDate: null,
  scheduledTime: null,
  customClassName: null,
};

export default AppointmentDueDate;
